var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRegLocation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 6.91547C4 3.31119 6.80577 0.799805 10.2 0.799805C13.5942 0.799805 16.4 3.31119 16.4 6.91547C16.4 8.22071 16.0299 9.61694 15.4312 10.667L10.6019 19.1397C10.5209 19.2839 10.3671 19.3734 10.2 19.3734C10.0329 19.3734 9.87905 19.2839 9.79815 19.1397L4.96875 10.667C4.37013 9.61698 4 8.22071 4 6.91547ZM7.21481 6.91547C7.21481 5.29461 8.55676 3.97089 10.2 3.97089C11.8432 3.97089 13.1852 5.29461 13.1852 6.91547C13.1852 8.53635 11.8432 9.86005 10.2 9.86005C8.55677 9.86005 7.21481 8.53635 7.21481 6.91547Z",
    fill: "#7BCB45"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2056_2192",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 13,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 6.91547C4 3.31119 6.80577 0.799805 10.2 0.799805C13.5942 0.799805 16.4 3.31119 16.4 6.91547C16.4 8.22071 16.0299 9.61694 15.4312 10.667L10.6019 19.1397C10.5209 19.2839 10.3671 19.3734 10.2 19.3734C10.0329 19.3734 9.87905 19.2839 9.79815 19.1397L4.96875 10.667C4.37013 9.61698 4 8.22071 4 6.91547ZM7.21481 6.91547C7.21481 5.29461 8.55676 3.97089 10.2 3.97089C11.8432 3.97089 13.1852 5.29461 13.1852 6.91547C13.1852 8.53635 11.8432 9.86005 10.2 9.86005C8.55677 9.86005 7.21481 8.53635 7.21481 6.91547Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2056_2192)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H20V20H0V0Z",
    fill: "#7BCB45"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRegLocation);
export default __webpack_public_path__ + "static/media/icRegLocation.468d5dd570ce5a034c10a22921f3c7ea.svg";
export { ForwardRef as ReactComponent };